<template>
  <el-select
    class="gb-select-api"
    v-bind="$attrs"

    v-model="syncedValue"
    filterable
  >
    <el-option
      v-for="item in options" :key="item.value"
      :label="item.label" :value="item.value" />
  </el-select>
</template>

<script>
/**GbSelectApi组件说明
 * el-select组件的options数据从后端获取推荐使用(封装了接口数据的处理)
*/
export default {
  name: 'GbSelectApi',
  inheritAttrs: false,

  props: {
    // 控件值
    value: {
      required: true
    },
    // 接口函数
    apiFunc: {
      type: Function,
      required: true
    },
    // 接口数据label与value的别名
    props: {
      type: Object,//格式{label: '别名', value: '别名'}
      required: true
    },
  },
  data() {
    return {
      options: []
    }
  },
  computed: {
    syncedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change');
        // 计算label名称
        let currentItem = this.options.filter(item => item.value == val);
        console.log('currentItem', currentItem);
        this.$emit('get-label', currentItem[0].label);
      }
    }
  },

  created() {
    this.assignOptions();
  },

  methods: {
    /**赋值options*/
    async assignOptions() {
      // let res = await this.apiFunc({
      //   params: {
      //     pageNum: 1,
      //     pageSize: 9999
      //   },
      //   data: {}
      // });
      let res = await this.apiFunc();
      // 后端响应数据格式不统一兼容处理
      let list = res.data.data || [];

      this.options = list.map((item, index) => ({
        label: item[this.props.label],
        value: item[this.props.value]
      }))

      // 特殊情况，将列表第一项value发送给父组件
      this.$emit('get-default-val', this.options[0].value, this.options[0].label)
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/global/GbSelectApi/index.vue